import { useEffect, useState, useMemo } from 'react';
import { getFirstName } from "../../../../helpers/formatting";
import { throttle } from 'lodash';

const useCarouselWidth = (elementRef, userList) => {
    const [carouselWidth, setCarouselWidth] = useState(0);
    const [proxyListWidth, setProxyListWidth] = useState(0);
    const proxyListPadding = 16;

    const updateCarouselWidth = () => {
        let carouselMaxWidth = 0;

        if (elementRef && elementRef?.current) {
            carouselMaxWidth = elementRef.current.clientWidth - 160;

            setCarouselWidth(carouselMaxWidth);
        }
    }

    const updateProxyListWidth = () => {
        let proxyWidth = 0;

        if (document && document.getElementsByClassName('slick-track') && document.getElementsByClassName('slick-track')[0]) {
            let slickList = document.getElementsByClassName('slick-track')[0];
            if (slickList?.children && slickList.children.length > 0 && (userList && userList.length > 0)) {
                let slickListWidth = 0;
                for (let i = 0; i < userList.length; i++) {
                    if (slickList.children[i]) {
                        slickListWidth += slickList.children[i].clientWidth;
                    }
                }
                if (slickListWidth > 0) {
                    proxyWidth = slickListWidth + proxyListPadding;
                }
                setProxyListWidth(proxyWidth);
            }
        }

        if (proxyWidth === 0 && (userList && userList.length > 0)) {
            const calculatedChar = userList.map((user) => getFirstName(user.displayName)).join('')
                .split('').reduce((accum, ch) => accum + 1, 0);
            const paddingValue = userList.length > 0 ? userList.length * proxyListPadding : 0;
            const calculatedWidth = calculatedChar * 10 + paddingValue;

            setProxyListWidth(calculatedWidth);
        }
    }

    const throttleUpdateCarouselWidth = useMemo(() => throttle(updateCarouselWidth, 150), []);

    useEffect(() => {
        window.addEventListener("resize", throttleUpdateCarouselWidth);
        updateCarouselWidth();
        updateProxyListWidth();
        return () => {
            window.removeEventListener("resize", throttleUpdateCarouselWidth);
            throttleUpdateCarouselWidth.cancel();
        }
    }, [elementRef, userList]);

    return {
        carouselWidth,
        proxyListWidth,
    };
};

export default useCarouselWidth;